import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        backdrop: (_a = {
                display: 'block',
                position: 'fixed',
                top: '0',
                bottom: '0',
                left: '0',
                right: '0',
                background: 'hsla(var(--gris-l3-h), var(--gris-l3-s), var(--gris-l3-l), 0.5)',
                opacity: 0,
                visibility: 'hidden',
                transition: 'var(--transition) opacity',
                zIndex: 3
            },
            _a[theme.breakpoints.down('sm')] = {
                zIndex: 2,
            },
            _a),
        backdropOpen: {
            opacity: 1,
            visibility: 'visible',
        },
    });
});
export default useStyles;
